import { render, staticRenderFns } from "./ps-ter.vue?vue&type=template&id=7635e44e&lang=html&"
import script from "./ps-ter.vue?vue&type=script&lang=js&"
export * from "./ps-ter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports